/**
 * @enum {{texture: string}}
 */
export const PlatformVariants = Object.freeze({
    STANDARD: { texture: 'platform_standard' },
    BLANK: { texture: 'platform_blank' },
    BREAKING: { texture: 'platform_breaking' },
    DYNAMIC: { texture: 'platform_dynamic' },
    SAW: { texture: 'platform_saw' },
});